import PortalHomeContainer from '@components/containers/b2b/portal/PortalHome';
import { B2B_NAV_ITEMS } from '@constants/sidebar';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

const PortalHome: FC = () => (
    <VendorLayout navItems={B2B_NAV_ITEMS}>
        <PortalHomeContainer />
    </VendorLayout>
);

export default PortalHome;
